import { render, staticRenderFns } from "./DeliveredCompanyProfile.vue?vue&type=template&id=22a99c82&"
import script from "./DeliveredCompanyProfile.vue?vue&type=script&lang=js&"
export * from "./DeliveredCompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredCompanyProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports